import React from 'react';
import cms from '@moka-fe/cms';

import InfoItem from './InfoItem';

import { Job } from '@/models/job';
import { getI18n } from '@/utils/i18n';

import styles from './JobManagerInfo.cm.styl';

const i18n = getI18n();

interface Props {
  currentJob: Job;
  headhunterJobFields: { [key in keyof Job]: boolean };
}

const JobManagerInfo: React.FC<Props> = ({ currentJob, headhunterJobFields }) => {
  const { managerName, managerPhone } = currentJob;
  return (
    <>
      <div className={styles.title}>
        {i18n.t`职位负责人信息`}
        <div className={styles.hr} />
      </div>
      <div className={cms.flexBetweenCenter}>
        <div className={styles.infoRow2}>
          <InfoItem name={i18n.t`姓名`} value={managerName ?? i18n.t`暂无职位负责人`} />
        </div>
        {!!headhunterJobFields.managerPhone && (
          <div className={styles.infoRow2}>
            <InfoItem name={i18n.t`手机号`} value={managerPhone ?? i18n.t`暂无`} />
          </div>
        )}
      </div>
    </>
  );
};

export default JobManagerInfo;
